export enum QuestionType {
  Verification = 'Verification',
  FreeResponse = 'Free Response',
  RatingScale = 'Rating Scale'
}
